<template>
  <div>
    <b-card>
      <template slot="header">
        <h4 class="mt-2 custom-card-header-text">Responses</h4>
        <ul class="list-inline float-right custom-header-rightstyle  header_table">
            <!-- <li class="list-inline-item">
                <button type="button" v-b-tooltip.hover.bottom title="Accepted" @click="openAction('accepted')" class="btn custom-card-header-filter btn-dropbox"><i class="cil-short-text"></i></button>
            </li>
            <li class="list-inline-item">
                <button type="button" v-b-tooltip.hover.bottom title="Decline" @click="openAction('declined')" class="btn custom-card-header-filter btn-dropbox"><i class="cil-short-text"></i></button>
            </li>
            <li class="list-inline-item">
                <button type="button" v-b-tooltip.hover.bottom title="Referred" @click="openAction('referred')" class="btn custom-card-header-filter btn-dropbox"><i class="cil-short-text"></i></button>
            </li>
            <li class="list-inline-item">
                <button type="button" v-b-tooltip.hover.bottom title="Pending" @click="openAction('pending')" class="btn custom-card-header-filter btn-dropbox"><i class="cil-short-text"></i></button>
            </li>
            <li class="list-inline-item">
                <button type="button" v-b-tooltip.hover.bottom title="In Review" @click="openAction('inreview')" class="btn custom-card-header-filter btn-dropbox"><i class="cil-short-text"></i></button>
            </li> -->
            <li v-if="communities.length>1" class="list-inline-item place-center"><label for="communityFilter" class="custom-card-header-filter label-bottom-0">Community:</label></li>
            <li v-if="communities.length>1" class="list-inline-item">
              <b-form-select v-model="selected" @change="filterByCommunity()" class="custom-card-header-filter" id="communityFilter">
                <option :value="null" selected disabled>Community</option>
                <option value="all">All</option>
                <option v-for="community in communities" :key="community._id" v-bind:value="community._id">{{ community.name}}</option>
              </b-form-select>
            </li>
            <li v-if="circles.length>=1" class="list-inline-item  place-center"><label for="circleFilter" class="custom-card-header-filter  label-bottom-0">Circle:</label></li>
            <li v-if="circles.length>=1" class="list-inline-item">
              <b-form-select v-model="selectedCircle" @change="filterByCircle()" class="custom-card-header-filter" id="circleFilter">
                <option :value="null" selected disabled>Circle</option>
                <option value="all">All</option>
							  <option value="none">No Circle</option>
                <option v-for="(circle, idx) in circles" :key="`${idx}$-{circle.short}`" v-bind:value="circle.short" v-if="circle.name && circles.length>=1" >{{ circle.name}}</option>
              </b-form-select>
            </li>
            <li>
              <div class="row-bak d-flex-bak align-items-center-bak">
                <datepicker @changed="dateFilter"
                :value="defaultDateRange"
                :initial-range="initialDateRange"
                style="padding-right: 10px;" label="Date Range"></datepicker>
              </div>
            </li>
            <li class="list-inline-item place-center"><label for="actionFilter" class="custom-card-header-filter  label-bottom-0">Response Type:</label></li>
            <li class="list-inline-item" v-if="!$route.query.action || $route.query.action === 'accepted'">
                <b-form-select v-model="selectedAction" v-on:change="filterByAction()" class="custom-card-header-filter" id="actionFilter">
                    <option value="All" selected>All Responses</option>
                    <option value="accepted">Accepted</option>
                    <option value="declined">Declined</option>
                    <option value="referred">Referred</option>
                    <option value="pending" v-if="authUser && authUser.role === 'SuperAdmin'">Pending</option>
                    <option value="inreview">In Review</option>
                    <option value="snoozed">Snoozed</option>
                </b-form-select>
            </li>
            <li class="list-inline-item">
                <button type="button" aria-label="Export" aria-live="assertive" v-if="exportBtn" @click="exportData()" title="Download response data" class="btn custom-card-header-filter btn-dropbox tab-focus"><i class="icon-cloud-download"></i></button>
                <button type="button" v-if="processBtn" v-b-tooltip.hover.bottom title="Generating report" class="btn custom-card-header-filter btn-dropbox"><i class="fa fa-spinner fa-spin"></i></button>
            </li>
        </ul>
      </template>
      <b-card-body>
        <search-section search-placeholder="Search Responses..." @search="handleSearch" @limit-change="handleLimitChange"/>
        <!-- The real table (header included) stays mounted and visible the whole time —
             only its rows get masked. Keeps its internal state intact and avoids a second,
             different-looking header. -->
        <div class="table-refresh-wrapper" :class="{ 'is-refreshing': isTableLoading }">
        <v-server-table v-if="isFiltersReady" ref="responseTable" :url="serverURL" :columns="columns" :options="options" name="dataTable" id="dataTable" @loaded="onLoaded" class="responses-table">
            <span slot="community" slot-scope="props">
              {{props.row.community ? props.row.community : 'N/A'}}
            </span>
            <span slot="title" slot-scope="props">
              {{props.row.title ? props.row.title : 'N/A'}}
            </span>
            <span slot="adviser" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
              {{props.row.adviser}}
            </span>
            <span slot="adviser" slot-scope="props" v-else-if="props.row.adviser">
              {{props.row.adviser}}
            </span>
            <span slot="sent" slot-scope="props" v-if="props.row.sent">
              {{ props.row.sent | momentDate }}
            </span>
            <span slot="sent" v-else>N/A</span>
            <span slot="status" v-if="props.row.isReferralGive == 'referred'" slot-scope="props" class="badge badge-warning">
            Referred
            </span>
            <span v-else slot="status" slot-scope="props" :class="[{'badge': props.row.status}, {'badge-success': setStatus(props.row.status) == 'Accepted'}, {'badge-danger': setStatus(props.row.status) == 'Declined'}, {'badge-blue': setStatus(props.row.status) == 'Snoozed'}, {'badge-warning': setStatus(props.row.status) == 'In Review' || setStatus(props.row.status, props.row) == 'Pending'}]">
              {{props.row.status ? setStatus(props.row.status) : 'N/A'}}
            </span>
            <span slot="followUp" slot-scope="props" class="capitalize" v-if="props.row.followUp">
              {{ props.row.followUp }}
            </span>
            <span slot="favorite" slot-scope="props" v-if="props.row.favorite">
            <button type="button" aria-live="assertive"
              class="btn custom-card-header-filter btn-transparent btn:focus tab-focus"
              @click="favoriteResponse(props.row, 'unfavorite')" v-b-tooltip.hover.bottom title="favorite"
              aria-label="favorite">
              <i class="fas fa-star gold-color" aria-label="favorite"></i>
            </button>
          </span>
          <span slot="favorite" slot-scope="props" v-else>
            <button type="button" aria-live="assertive"
              class="btn custom-card-header-filter btn-transparent btn:focus tab-focus"
              @click="favoriteResponse(props.row, 'favorite')" v-b-tooltip.hover.bottom title="unfavorite"><i
                class="far fa-star" aria-label="unfavorite"></i></button>
          </span>
          <span slot="action" slot-scope="props" class="center-dropdown">
            <b-dropdown v-b-tooltip.hover.bottom title="Take action" variant="btn btn-dropbox btn-sm tab-focus" right>
              <template #button-content>
                <i class="icon-settings"></i>
              </template>
              <b-dropdown-item @click="openRequestInNewTab(props.row.requestId)">View Request</b-dropdown-item>
              <b-dropdown-item @click="openResponseModal(props.row.advice)">View Response</b-dropdown-item>
              <b-dropdown-item
                @click="approveResponse(props.row.requestId, props.row.giveId, 'approve', 'no', props.row.giveType)">Approve
                Response</b-dropdown-item>
              <b-dropdown-item
                @click="approveResponse(props.row.requestId, props.row.giveId, 'approve', 'yes', props.row.giveType)">Approve
                Member</b-dropdown-item>
              <b-dropdown-item
                @click="$router.push(`/engagement/requests-response-coach/${props.row.requestId}/${props.row.giveId}/?location=responses`)">Reject
                and coach</b-dropdown-item>
              <b-dropdown-item
                @click="approveResponse(props.row.requestId, props.row.giveId, 'reject', 'no', props.row.giveType)">Reject
                and delete</b-dropdown-item>
            </b-dropdown>
          </span>
        </v-server-table>
        </div>
      </b-card-body>
    </b-card>
    <b-modal id="response-modal" class="response-modal" size="lg" v-model="responseModal" ok-title="Close"
      @ok="responseModal = false">
      {{ giveAdvice }}
    </b-modal>
  </div>
</template>

<script>
import { shuffleArray } from '@/shared/utils';
import axios from 'axios';
import { exportCSV, toDayParam, pickedDayToUtc, dayParamToLocal, lastNDaysStart } from '@/assets/js/common';
var moment = require('moment-timezone');
import VueNotifications from 'vue-notifications'
import { setResponseStatus } from '@/assets/js/set-status';
import datepicker from './components/datePicker';
import { sanitizeInput, sanitizeUrl, sanitizeHtmlTemplate, sanitizeResourceDescription } from '../../utils/sanitizer';
import SearchSection from '@/views/engagement/components/searchSection.vue';

export default {
  name: 'responses',
  components: {
    datepicker,
    SearchSection
	},
  data() {
    return {
      responses: [],
      communities: [],
      circles: [],
      searchQuery: '',
      askCount: 0,
      isTableLoading: false,
      selected: "all",
      selectedCircle: "all",
      selectedAction: "All",
      selectedDates: {
				startDate: new Date(0),
				endDate: new Date()
			},
      defaultDateRange: null,
      initialDateRange: null,
      // True when the range is "Custom dates" (local calendar days).
      isCustomRange: false,
      actions: ['accepted', 'declined', 'referred', 'pending', 'in review'],
      columns: ['community', 'circleName', 'sent', 'adviser', 'request_Action', 'status', 'open', 'click', 'thankYou', 'followUp', 'favorite', 'action'],
      token: '',
      perPage: 25,
      options: {
        headings: {
          requestId: 'Request ID',
          open: function (h) {return <span data-title="Total opens: every time the asker opened the response, repeats included">O</span>},
          click: function (h) {return <span data-title="Total clicks: every click by the asker in the response email, repeats included">C</span>},
          thankYou: function (h) {return <span data-title="Askers that thanked the Advisor">TY</span>},
          followUp: function (h) {return <span data-title="Askers that followed up">FU</span>},
          circleName: 'Circle',
          favorite: function (h) {return <span data-title="Favorite requests"><i class="fa-regular fa-star" aria-hidden="true"></i></span>}
        },
        sortable: ['circleName', 'sent', 'adviser', 'request_Action', 'status', 'favorite'],
        // sortable: ['sent', 'adviser', 'request_Action', 'status', 'open', 'click'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
					show: false,
					dropdown: false,
          chunk: 10,
          nav: 'fixed'
        },
        requestFunction: async function (data) {
          if (data.query) {
                // Reset if malicious content is detected
                if (data.query.toLowerCase().includes('javascript:') ||
                    data.query.toLowerCase().includes('data:') ||
                    data.query.toLowerCase().includes('vbscript:')) {
                    data.query = '';
                    // Reset the filter input
                    const table = this.$parent.$refs.dataTable;
                    if (table && table.$refs.filter) {
                        table.$refs.filter.value = '';
                    }
                }
                data.query = sanitizeInput(data.query);
            }
            this.$parent.searchQuery = data.query;
            // Do NOT re-inject action from $route.query here — that's the value from when
            // the page first loaded (the route itself never updates when the dropdown
            // changes), and buildResponseQueries() treats `queryAction` as an override
            // that WINS over `action`. That silently pinned every request back to the
            // original action forever, no matter what the dropdown was changed to.
            // `this.url` (serverURL) already carries the live, current action — nothing
            // extra needs to be sent here.
            this.$parent.isTableLoading = true;
            return await axios.get(this.url, {headers: {'x-access-token': localStorage.getItem('token')},  params: data})
                .catch(function (e) {
                    if (e.response.status  === 401) {
                        localStorage.removeItem('authUser');
                        this.$router.push('/login');
                    }
                }.bind(this))
                .finally(function () { this.$parent.isTableLoading = false; }.bind(this));
        },
        responseAdapter({data}) {
            this.$parent.askCount = data.askCount;
            return {
                data : data.responses,
                count: data.askCount
            }
        },
				filterable: true,
				perPageDropdown: [],
        // Blank out the library's own "Loading..." placeholder — it rendered as a
        // second, overlapping loading message alongside our own indicator above.
        texts: { loading: '' },
        customSorting: {
          sent: function (ascending) {
              return function (a, b) {
                  var isValid = function(date) {
                    return !isNaN(isFinite(date))
                  }
                  var lastA = a.sent;
                  var lastB = b.sent;
                  if (ascending && isValid(lastA) && isValid(lastB)) {
                    return new Date(lastA) - new Date(lastB);
                  }
                  if (!ascending && isValid(lastA) && isValid(lastB)) {
                    return lastA <= lastB ? 1 : -1;
                  }
              }
          }
        }
      },
      serverURL: `${process.env.VUE_APP_API_BASE_URL}/dashboard/response`,
      isFiltersReady: false,
      userData: {},
      exportBtn: true,
      processBtn: false,
      downloadBtn: false,
      responseModal: false,
      giveAdvice: '',
    }
  },
  notifications: {
      showDownloadingMsg: {
        type: VueNotifications.types.success,
        message: "Export request sent.  Data is now downloading."
      },
      showWarnMsg: {
          type: VueNotifications.types.warn,
          message: "No data found for export file"
      }
  },
  async created() {
    if (this.$route.query.status) {
      console.log("this.$route.query.status", this.$route.query.status.trim());
    if (this.$route.query.status.trim() === 'approved') {
      console.log("this is running");
      this.showSuccessMsg({ message: 'The give is already approved.' });
    } else if (this.$route.query.status.trim() === 'rejected') {
      this.showErrorMsg({ message: 'The give is already rejected.' });
    }
    const newQuery = { ...this.$route.query };
      delete newQuery.status;
      this.$router.replace({ query: newQuery });
    }
    if (this.$route.query.action) {
        this.selectedAction = this.$route.query.action;
    }
    // Apply timeframe from query params (example  navigated from Dashboard Alumni Engaged widget)
    const timeframe = this.$route.query.timeframe;
    if (timeframe) {
        const timeframeToDateRange = { weekly: 'last-7', monthly: 'last-30', ytd: 'ytd', all: null, custom: 'custom' };
        this.defaultDateRange = timeframe in timeframeToDateRange ? timeframeToDateRange[timeframe] : null;

        // Compute and set selectedDates immediately so that the first API fetch
        const now = new Date();
        const startDateParam = this.$route.query.startDate;
        const endDateParam = this.$route.query.endDate;
        // A widget forwards the exact instant it used for its own count (see
        // Dashboard.vue's getWidgetDateRange()/_widgetDateRange) — honor it whenever
        // present, regardless of timeframe. Previously this was only read for
        // timeframe=custom, so weekly/monthly/ytd recomputed a fresh "now" here,
        // independently of the widget, drifting from it by a boundary record
        // (confirmed: widget vs. this table, off by exactly one).
        if (startDateParam && endDateParam) {
            // A forwarded custom range is local calendar days (shown in the picker);
            // forwarded presets are UTC days. dayParam() re-anchors accordingly.
            this.isCustomRange = timeframe === 'custom';
            const parse = this.isCustomRange ? dayParamToLocal : (v) => new Date(v);
            this.selectedDates.startDate = parse(startDateParam);
            this.selectedDates.endDate = parse(endDateParam);
            this.initialDateRange = { start: dayParamToLocal(startDateParam), end: dayParamToLocal(endDateParam) };
        } else if (timeframe === 'weekly') {
            this.selectedDates.startDate = lastNDaysStart(7, now);
            this.selectedDates.endDate = now;
        } else if (timeframe === 'monthly') {
            this.selectedDates.startDate = lastNDaysStart(30, now);
            this.selectedDates.endDate = now;
        } else if (timeframe === 'ytd') {
            this.selectedDates.startDate = new Date(now.getFullYear(), 0, 1);
            this.selectedDates.endDate = now;
        }
        // timeframe === 'all' keeps the default
    } else {
        // No explicit timeframe: default to Last 30 Days, computed exactly like the
        // Dashboard widget (Dashboard.vue loadDashboardData) — raw now-30d / now,
        // with day snapping left to the server's resolveDateRange(). Pre-snapping to
        // UTC midnight here lands on the previous REPORT_TIMEZONE day and widens the
        // window to 31 days (table showed 373 vs. widget's 371).
        this.defaultDateRange = 'last-30';
        this.selectedDates.startDate = lastNDaysStart(30);
        this.selectedDates.endDate = new Date();
    }
    this.token = localStorage.getItem('token');
    const user = localStorage.getItem('authUser');
    if(user) {
        this.authUser = JSON.parse(user);
    }

    // Pre-select community from URL or localStorage BEFORE the first await.
    const communityIdParam = this.$route.params.community_id
        || this.$route.query.community_id
        || localStorage.getItem('user_modal_option');
    if (communityIdParam && communityIdParam !== 'all') {
        this.selected = communityIdParam;
    }
    
    this.serverURL = this.buildResponseURL(this.selectedAction, this.selected, this.selectedCircle, this.selectedDates.startDate, this.selectedDates.endDate);

    await this.getCommunities();
    this.isFiltersReady = true;
    await this.loadData();
  },
  methods: {
    // Send a bare "YYYY-MM-DD" day (toDayParam in common.js), never a raw Date
    // (its .toString() isn't URL-safe) or an ISO instant (the server's time-zone
    // snap slid "00:00Z" into the previous day, so this table counted one more
    // day than the Dashboard widget linking here and the Reports CSV).
    toDateParam(date) {
      return toDayParam(this.isCustomRange ? pickedDayToUtc(date) : date);
    },
    buildResponseURL(action, community, circle, startDate, endDate) {
      let url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/response/?action=${action}&community=${community}&circle=${circle}&startDate=${this.toDateParam(startDate)}&endDate=${this.toDateParam(endDate)}`;
      if (this.authUser && this.authUser.role === 'Admin') {
        url += '&excludeStatus=Pending';
      }
      return url;
    },
    async favoriteResponse(requestId, requestType) {
      const favorite = requestType == 'favorite' ? true : false;
      requestId.favorite = favorite;
      await this.axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/dashboard/favorite-response`,
				{askId: requestId, favorite: favorite,requestType: requestType},
				{ headers: {'x-access-token': this.token}}).then(async (response) => {

				if (this.$refs.responseTable && this.$refs.responseTable.storedParams) {
        this.$parent.searchQuery = this.$refs.responseTable.storedParams.query;

        if (this.$route.query.tag) {
          this.$refs.responseTable.storedParams.tag = this.$route.query.tag;
        }

        const result = await axios.get(this.serverURL, {
          headers: { 'x-access-token': localStorage.getItem('token') },
          params: this.$refs.responseTable.storedParams
        }).catch(() => {});

        this.$refs.responseTable.setData(result);
      }
			});
		},
    dateFilter(res) {
			// console.log("dates [selectedDates]:", res);
			this.selectedDates.startDate =  res.startDate;
			this.selectedDates.endDate =  res.endDate;
			this.isCustomRange = res.selectedValue === 'custom';
			this.onLoaded();
		},
    onLoaded() {
      if (this.selected) {
        this.serverURL = this.buildResponseURL(this.selectedAction, this.selected, this.selectedCircle, this.selectedDates.startDate, this.selectedDates.endDate);
      }
    },
    loadData() {
        var user = localStorage.getItem('authUser');
        this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/users/${JSON.parse(user)._id}/edit-profile`, {headers: {'x-access-token': this.token}}).then(response => {
            if (response.data.user) {
                this.userData = response.data.user;
                this.exportBtn = true;
                this.processBtn = false;
                this.downloadBtn = false;
                if (response.data.user.responseCSVFileName) {
                    this.exportBtn = false;
                    this.processBtn = false;
                    this.downloadBtn = true;
                } else if (response.data.user.responseExportCSV) {
                    this.exportBtn = false;
                    this.processBtn = true;
                    this.downloadBtn = false;
                }
            }
        }).catch(err => {
            if (err.response.status === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
        var queryParams = {
            headers: {'x-access-token': this.token}
        }
        if (this.selected && this.selected != 'all') {
            queryParams.params = {community: this.selected};
        }
        this.$helpers.setTabindexOnTableCells();
    },
    checkData(value) {
      if(value) { return value; } else { return 'N/A';}
    },
    showSuccessMsg({ message }) {
        VueNotifications.success({ message });
    },
    showErrorMsg({ message }) {
        VueNotifications.error({ message });
    },
    announcement(message) {
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('role', 'alert');
        liveRegion.innerText = message;
        document.body.appendChild(liveRegion);
        setTimeout(() => {
            liveRegion.remove();
        }, 1000);
    },
    approveResponse: function(askId, giveId, action, status,giveType) {
      console.log("giveType", giveType);
      console.log("askId", askId);
      console.log("giveId", giveId);
      console.log("action", action);
      console.log("status", status);
      if(giveType==='in review' || giveType==='pending'){
        let params = {
            askId: askId,
            giveId: giveId,
            action: action,
            status: status,
            approvedBy: 'dashboard'
        }
        console.log("authUser", this.authUser);
        if (this.authUser.memberID) {
            params.adminId = this.authUser.memberID;
        }
        this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response-approval`, params, {headers: {'x-access-token': this.token}}).then(async response => {
            // setTimeout(async () => {
              await this.loadData();
              let message = '';
              if (action == 'approve') {
                message = 'Thank you for approving the response.'
                this.showSuccessMsg({message: message});
                this.announcement(message);
              } else if (action == 'reject') {
                message = 'Thank you for your response';
                this.showSuccessMsg({message: message})
                this.announcement(message);
              }
            // }, 2000);
        }).catch(err => {
            if (err.response.status  === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
      }
      else{
        let message = '';
      if (giveType === 'accepted') {
        message = 'The response has already been accepted.';
      } else if (giveType === 'declined') {
        message = 'The response has already been declined.';
      } else if (giveType === 'referred') {
        message = 'The response has already been referred.';
      }
      this.showErrorMsg({ message: message });
      this.announcement(message);
      }
    },
    async getCommunities() {
      const {data} = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/sidebar-community`, {headers: {'x-access-token': this.token}})
      .catch(err => {
        if (err.response.status  === 401) {
          localStorage.removeItem('authUser');
          this.$router.push('/login');
        }
      });
      this.communities = data;
      const communityId = this.$route.params.community_id || this.$route.query.community_id || localStorage.getItem('user_modal_option');
      if(communityId && communityId !== 'all') {
        var selectedCommunity = data.filter(community => community._id == communityId);
        if (selectedCommunity.length >= 1) {
					this.selected = selectedCommunity[0]._id;
				}
			} else {
				// Only auto-select when no community was already set.
				const isValid = this.communities.some(c => c._id === this.selected);
				if (!isValid) {
					this.selected = this.communities.length <= 1 ? this.communities[0]._id : 'all';
				}
			}
			this.filterByCommunity();
			// Read circle from query params (passed from the dashboard widget) — applied
			// after filterByCommunity() since that resets selectedCircle to "all" and
			// rebuilds `circles` for the now-selected community. Mirrors requests.vue.
			const circleParam = this.$route.query.circle;
			if (circleParam && circleParam !== 'all') {
				this.selectedCircle = circleParam;
				this.filterByCircle();
			}
    },
    filterByCommunity: async function (value) {
      this.selectedCircle = "all";
      if (this.selected == "all") {
        this.circles = [];
      } else {
        this.circles = this.communities.find(c => c._id == this.selected).additionalParams;
        this.circles.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      }
      this.serverURL = this.buildResponseURL(this.selectedAction, this.selected, 'all', this.selectedDates.startDate, this.selectedDates.endDate);
    },
    filterByCircle: async function () {
      this.serverURL = this.buildResponseURL(this.selectedAction, this.selected, this.selectedCircle, this.selectedDates.startDate, this.selectedDates.endDate);
    },
    filterByAction: async function () {
      this.serverURL = this.buildResponseURL(this.selectedAction, this.selected, this.selectedCircle, this.selectedDates.startDate, this.selectedDates.endDate);
    },
    setStatus: function (status) {
      return setResponseStatus(status);
    },
    sanitizeInput(input) {
      return sanitizeInput(input);
    },
    sanitizeUrl(url) {
      return sanitizeUrl(url);
    },
    sanitizeHtmlTemplate(template) {
      return sanitizeHtmlTemplate(template);
    },
    sanitizeResourceDescription(description) {
      return sanitizeResourceDescription(description);
    },
    exportData: function() {
      if (this.askCount > 0) {
        this.showDownloadingMsg();
				this.exportBtn = false;
				this.processBtn = true;
        var queryParams = {
            headers: {'x-access-token': this.token}
        }
        // Mirror buildResponseURL()'s Admin-only Pending exclusion (above) — without
        // this the export includes Pending responses that Admins never see in the table.
        const excludeStatusParam = (this.authUser && this.authUser.role === 'Admin') ? '&excludeStatus=Pending' : '';
        this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response/export/?action=${this.selectedAction}&community=${this.selected}&circle=${this.selectedCircle}&query=${this.searchQuery}${excludeStatusParam}&&startDate=${this.toDateParam(this.selectedDates.startDate)}&&endDate=${this.toDateParam(this.selectedDates.endDate)}`, queryParams).then(async response => {
          if (response.data.responses.length) {
              let responseData = this.$lodash.orderBy(response.data.responses, ['sent'], ['desc']);
              await exportCSV(responseData.slice(),  'responses', ['title','memberId', 'isReferralGive', 'commentCount'], ['sent']);
              this.exportBtn = true;
						  this.processBtn = false;
          } else {
            this.showWarnMsg();
            this.exportBtn = true;
            this.processBtn = false;
          }
        }).catch(err => {
            if (err.response.status  === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
      } else {
        this.showWarnMsg();
      }
    },
    downloadCSV: function() {
        if (this.userData && this.userData.responseCSVFileName) {
            var file = this.userData.responseCSVFileName;
            axios({
                method: 'get',
                url: `${process.env.VUE_APP_API_BASE_URL}/member/${this.userData._id}/${this.userData.responseCSVFileName}`,
                responseType: 'arraybuffer'
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', file) //or any other extension
                document.body.appendChild(link)
                link.click()
                this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response/responseRemoveCSV`, { headers: {'x-access-token': this.token} }).then(response => {
                    this.exportBtn = true;
                    this.processBtn = false;
                    this.downloadBtn = false;
                }).catch(err => {
                    if (err.response.status  === 401) {
                        localStorage.removeItem('authUser');
                        this.$router.push('/login');
                    }
                });
            }).catch(() => console.log('error occured'))
        }
    },
    /*
    openAction: function(action) {
        window.open((`/engagement/responses/?action=${action}`), '_blank');
    },
    */
    redirectUrls: function(path) {
        window.open((`/engagement/members/${path}`), '_blank');
    },
    openRequestInNewTab(path) {
      window.open((`/engagement/requests/${path}`), '_blank');
    },
    openResponseModal(advice) {
      this.giveAdvice = advice;
      this.responseModal = true;
    },
		handleSearch(searchText) {
			// Use the search text from the child component to filter your requests table
			this.$refs.responseTable.setFilter(searchText);
		},
		handleLimitChange(newLimit) {
			// Use the new limit value from the child to update your requests table
			this.$refs.responseTable.setLimit(newLimit);
		}
  }
}
</script>

<style lang="scss">
.evaluation-modal {
  .modal-dialog { max-width: 460px; }
  .modal-content {
    background: transparent;
    border: none;
    box-shadow: none;
  }
  .modal-body { padding: 0; }
}
</style>
<style scoped>
/* ::v-deep reaches into v-server-table's own rendered markup — it's a separate
   component, so plain scoped CSS on this file can't touch its <tbody> otherwise.
   Each cell keeps its own real, browser-computed size and position — no absolute
   positioning or header-height guessing, so this can't misalign with the real
   header the way an overlay could. Only the cell's TEXT is hidden and swapped
   for a shimmer bar drawn in the same spot; the real <thead> is never touched. */
.table-refresh-wrapper.is-refreshing ::v-deep tbody td {
	position: relative;
	color: transparent !important;
}
.table-refresh-wrapper.is-refreshing ::v-deep tbody td * {
	visibility: hidden;
}
.table-refresh-wrapper.is-refreshing ::v-deep tbody td::before {
	content: '';
	position: absolute;
	top: 6px;
	bottom: 6px;
	left: 8px;
	right: 8px;
	border-radius: 4px;
	background: linear-gradient(90deg, rgba(255, 255, 255, 0.06) 25%, rgba(255, 255, 255, 0.14) 37%, rgba(255, 255, 255, 0.06) 63%);
	background-size: 400% 100%;
	animation: table-skeleton-pulse 1.4s ease infinite;
}
@keyframes table-skeleton-pulse {
	0% { background-position: 100% 50%; }
	100% { background-position: 0% 50%; }
}
</style>